import dynamic from 'next/dynamic';
export const CarouselCards = dynamic(() => import('./CarouselCards'));
export { default } from './CarouselCards';
